import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const STORAGE_KEY = "secrets_age_confirmed";

export const AgeGate = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let confirmed = false;
    try {
      confirmed = localStorage.getItem(STORAGE_KEY) === "true";
    } catch (_) {
      confirmed = false;
    }

    if (!confirmed) {
      setVisible(true);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const confirmAge = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "true");
    } catch (_) {}
    document.body.style.overflow = "";
    setVisible(false);
  };

  const rejectAge = () => {
    localStorage.removeItem(STORAGE_KEY);
    window.open("", "_self");
    window.close();
    setTimeout(() => {
      window.location.replace("about:blank");
    }, 120);
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[10000] flex min-h-dvh items-center justify-center overflow-y-auto overscroll-contain bg-black/95 px-4 py-6 pointer-events-auto md:px-5 md:py-8 md:backdrop-blur-md"
      role="dialog"
      aria-modal="true"
      aria-labelledby="age-gate-title"
    >
      <motion.div
        initial={{ opacity: 0, y: 24, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.35, ease: "easeOut" }}
        className="my-auto w-full max-w-lg rounded-lg border border-red-900/50 bg-[#090909] p-6 text-center shadow-2xl shadow-red-950/30 sm:p-9"
      >
        <p className="mb-3 font-['Manrope'] text-xs uppercase tracking-[0.2em] text-[#C9A45C]">
          Confirmação obrigatória
        </p>
        <h1
          id="age-gate-title"
          className="font-['Cormorant_Garamond'] text-3xl font-normal text-white sm:text-4xl"
        >
          Você tem 18 anos ou mais?
        </h1>
        <p className="mx-auto mt-4 max-w-md text-sm leading-6 text-[#A3A3A3] sm:text-base">
          Por determinação legal e em conformidade com as regras de proteção de menores na internet, o acesso ao Secrets Club é permitido apenas para maiores de 18 anos.
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={confirmAge}
            className="flex-1 cursor-pointer touch-manipulation select-none rounded-md bg-[#CC0000] px-5 py-3 font-['Manrope'] text-sm font-semibold uppercase tracking-[0.14em] text-white transition hover:bg-[#A80000] focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-black"
          >
            Sim, tenho 18 anos
          </button>
          <button
            type="button"
            onClick={rejectAge}
            className="flex-1 cursor-pointer touch-manipulation select-none rounded-md border border-white/15 bg-white/5 px-5 py-3 font-['Manrope'] text-sm font-semibold uppercase tracking-[0.12em] text-white transition hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/40 focus:ring-offset-2 focus:ring-offset-black"
          >
            Não tenho 18 anos
          </button>
        </div>
      </motion.div>
    </div>
  );
};
